import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { BlFacadeService } from "./bl-facade.service";
import { BonLivraison } from "../../models/bon-livraison.model";

@Injectable({ providedIn: "root" })
export class BlStoreService extends EntityStoreService<
  BonLivraison,
  EntityMetadata,
  BlState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
    });
  }
}

export interface BlState extends EntityStoreState<BlFacadeService> {}
